import { render, staticRenderFns } from "./createStepOne.vue?vue&type=template&id=72c98752&scoped=true"
import script from "./createStepOne.vue?vue&type=script&lang=js"
export * from "./createStepOne.vue?vue&type=script&lang=js"
import style0 from "./createStepOne.vue?vue&type=style&index=0&id=72c98752&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c98752",
  null
  
)

export default component.exports